import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SsoAuthService } from '../../SsoAuth/Service/sso-auth.service';
import { environment } from '../../environments/environment.development';

export const accoInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const ssoService = inject(SsoAuthService);
  const token = localStorage.getItem('userToken');
  
  if (req.url.includes('/auth/sign')) {
    return next(req);
  }

  const isOperatorApi = req.url === environment.BASE_URL
    || req.url.startsWith(`${environment.BASE_URL}/`);
  const isCommonApi = req.url === environment.COMMON_BASE_URL
    || req.url.startsWith(`${environment.COMMON_BASE_URL}/`);

  if (token && (isOperatorApi || isCommonApi)) {
    const headers: { [name: string]: string } = {
      Authorization: `Bearer ${token}`,
    };
    // Branch context belongs to the operator API. Do not send this custom
    // header to the shared accommodation API: its CORS contract accepts the
    // bearer token but not x-establishment-id.
    if (isOperatorApi) {
      const hasExplicitEstablishment = req.headers.has('x-establishment-id');
      const activeEstablishmentId = localStorage.getItem('activeEstablishmentId');
      if (activeEstablishmentId && !hasExplicitEstablishment) {
        headers['x-establishment-id'] = activeEstablishmentId;
      }
      // Super Admin viewing the app as a role: the API checks that role's template
      try {
        const viewAs = JSON.parse(localStorage.getItem('viewAs') || 'null');
        if (viewAs?.roleId) headers['x-view-as-role'] = String(viewAs.roleId);
      } catch {
        // no view-as state
      }
    }
    req = req.clone({ setHeaders: headers });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        ssoService.logOut(true);
      }

      return throwError(() => error);
    })
  );
};
